import { create } from "zustand";

type ArticleResourceData = Record<string, Buffer>;
type ResourceData = Record<string, ArticleResourceData>;

interface ResourceStoreState {
	data: ResourceData;
	update: (articlePath: string) => (src: string, buffer: Buffer) => void;
	get: (articlePath: string) => (src: string) => Buffer | undefined;
	clear: () => void;
	remove: (src: string) => void;
}

export const useResourceStore = create<ResourceStoreState>((set, get) => ({
	data: {},

	update: (articlePath) => (src: string, buffer: Buffer) => {
		set((state) => ({
			data: { ...state.data, [articlePath]: { ...(state.data[articlePath] || {}), [src]: buffer } },
		}));
	},

	get: (articlePath) => (src: string) => {
		return get().data[articlePath][src];
	},

	clear: () => {
		set({ data: {} });
	},

	remove: (src: string) => {
		set((state) => {
			const { [src]: _, ...rest } = state.data;
			return { data: rest };
		});
	},
}));
